const c = [
	() => import("../../../src/routes/__layout.svelte"),
	() => import("../components/error.svelte"),
	() => import("../../../src/routes/index.svelte"),
	() => import("../../../src/routes/mint-old.svelte"),
	() => import("../../../src/routes/bleeps.svelte"),
	() => import("../../../src/routes/create.svelte"),
	() => import("../../../src/routes/about.svelte"),
	() => import("../../../src/routes/mint.svelte"),
	() => import("../../../src/routes/test.svelte")
];

const d = decodeURIComponent;

export const routes = [
	// src/routes/index.svelte
	[/^\/$/, [c[0], c[2]], [c[1]]],

	// src/routes/mint-old.svelte
	[/^\/mint-old\/?$/, [c[0], c[3]], [c[1]]],

	// src/routes/bleeps.svelte
	[/^\/bleeps\/?$/, [c[0], c[4]], [c[1]]],

	// src/routes/create.svelte
	[/^\/create\/?$/, [c[0], c[5]], [c[1]]],

	// src/routes/about.svelte
	[/^\/about\/?$/, [c[0], c[6]], [c[1]]],

	// src/routes/mint.svelte
	[/^\/mint\/?$/, [c[0], c[7]], [c[1]]],

	// src/routes/test.svelte
	[/^\/test\/?$/, [c[0], c[8]], [c[1]]]
];

// we import the root layout/error components eagerly, so that
// connectivity errors after initialisation don't nuke the app
export const fallback = [c[0](), c[1]()];